'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var LEAVE_EVENT = exports.LEAVE_EVENT = 'leave';
var JOIN_EVENT = exports.JOIN_EVENT = 'join';
var TIMEOUT_EVENT = exports.TIMEOUT_EVENT = 'timeout';
var STATE_CHANGE = exports.STATE_CHANGE = 'state-change';


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-core/static-1.139/js/constants/PubNubPresenceEventTypes.js
// module id = 428
// module chunks = 0